import { FaqServiceSupportThemeModeConfig } from './types';

const light: FaqServiceSupportThemeModeConfig = {
  faqServiceSupport: {},
};

export default light;
